function HouseCommonData(userInputRepository, houseForm) {

    var commonData = null ;

    this.data = {} ;

    function set(item, value) {
        commonData[item] = value ;
    }

    function getCommonMaterial() {
        return houseForm.commonMaterial ;
    }


}
